module.exports = __webpack_public_path__ + "img/img-3-12mobile.aca328f8.png";